import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

type AccordionProps = {
    children?: React.ReactNode
    name: React.ReactNode
    defaultOpen?: boolean
    keepMounted?: boolean
    actions?: React.ReactNode
    className?: string
    triggerClassName?: string
    contentClassName?: string
    bodyClassName?: string
}

const Accordion = ({
    children,
    name,
    defaultOpen = false,
    keepMounted = true,
    actions,
    className,
    triggerClassName,
    contentClassName,
    bodyClassName
}: AccordionProps) => {
    const [open, setOpen] = useState(defaultOpen)
    const handleOpen = () => setOpen((prev) => !prev)

    return (
        <div className={className}>
            <div className='flex items-center gap-2'>
                <Button
                    type='button'
                    variant='ghost'
                    onClick={handleOpen}
                    className={cn(
                        'h-auto flex-1 items-center justify-between rounded-lg px-4 py-3 text-left font-normal whitespace-normal transition-all',
                        triggerClassName
                    )}
                >
                    <span>{name}</span>
                    <ChevronDown className={cn('size-5 transition-transform duration-200', open && 'rotate-180')} />
                </Button>
                {actions && <div className='shrink-0'>{actions}</div>}
            </div>

            <div
                className={cn(
                    'grid overflow-hidden transition-all duration-300 ease-linear',
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
                    contentClassName
                )}
            >
                <div className='min-h-0 overflow-hidden'>
                    <div className={bodyClassName}>{(open || keepMounted) ? children : null}</div>
                </div>
            </div>
        </div>
    )
}

export default Accordion
